import { PaymentFrequency } from "@repo/api";
import { FC } from "react";
import { PaymentHeader } from "../Payments/PaymentHeader";

type TransactionsTabTopCardsProps = {
    contribution: number | undefined;
    paymentFrequency?: PaymentFrequency | null;
    debt: number | undefined;
    paidToDate?: Date | null;
    hideDebt?: boolean;
    contributionLabel?: string;
};

export const TransactionsTabTopCards: FC<TransactionsTabTopCardsProps> = ({
    contribution,
    debt,
    paidToDate,
    paymentFrequency,
    hideDebt,
    contributionLabel,
}) => {
    return (
        <PaymentHeader
            contribution={contribution}
            debt={debt ?? undefined}
            paidToDate={paidToDate ?? undefined}
            paymentFrequency={paymentFrequency}
            hideDebt={hideDebt}
            contributionLabel={contributionLabel}
        />
    );
};
